import { IOrderCenterForm, IOrderCenterItem } from '../../../models/constants';
import * as CON from '../../common/constants';

const PRODUCT_FORMS_CA: IOrderCenterItem[] = [
    {
        title: 'Standard Hearing Aid Order Form',
        englishPdf: 'Standard_Hearing_Aid_Order_Form.pdf',
        localePdf: 'Standard_Hearing_Aid_Order_Form_FR.pdf',
    },
    {
        title: 'Custom Hearing Aid Order Form',
        englishPdf: 'Custom_Hearing_Aid_Order_Form.pdf',
        localePdf: 'Custom_Hearing_Aid_Order_Form_FR.pdf',
    },
    {
        title: 'Battery Order Form',
        englishPdf: 'Battery_Order_Form.pdf',
        localePdf: 'Battery_Order_Form_FR.pdf',
    },
    {
        title: 'Tunz Order Form',
        englishPdf: 'Tunz_Order_Form.pdf',
    },
];
const EMFORMS_CA: IOrderCenterItem[] = [
    {
        title: 'Earmold Order Form',
        englishPdf: 'Earmold_Order_Form.pdf',
        localePdf: 'Earmold_Order_Form_French.pdf',
    },
];

const SERVICE_REPAIR_FORMS_CA: IOrderCenterItem[] = [
    {
        title: 'Credit Refund Form',
        localePdf: 'Credit_Refund_Form_French.pdf',
    },
];

const FORMS_CA: IOrderCenterForm = {
    productForms: PRODUCT_FORMS_CA,
    earmoldForms: EMFORMS_CA,
    serviceRepairForms: SERVICE_REPAIR_FORMS_CA,
};

const PRODUCT_FORMS_KR: IOrderCenterItem[] = [
    {
        title: 'Custom Hearing Aid Order Form',
        englishPdf: 'Custom_Hearing_Aid_Order_Form.pdf',
        localePdf: 'Custom_Hearing_Aid_Order_Form_KR.pdf',
    },
];
const EMFORMS_KR: IOrderCenterItem[] = [
    {
        title: 'Earmold Order Form',
        englishPdf: 'Earmold_Order_Form.pdf',
        localePdf: 'Earmold_Order_Form_KR.pdf',
    },
];
const SERVICE_REPAIR_FORMS_KR: IOrderCenterItem[] = [
    {
        title: 'Repair Order Form',
        localePdf: 'Repair_Order_Form_KR.pdf',
    },
];

const FORMS_KR: IOrderCenterForm = {
    productForms: PRODUCT_FORMS_KR,
    earmoldForms: EMFORMS_KR,
    serviceRepairForms: SERVICE_REPAIR_FORMS_KR,
};
//==================================================//
const PRODUCT_FORMS_DE: IOrderCenterItem[] = [
    {
        title: 'Order Form',
        brand: CON.STARKEY,
        localePdf:
            'https://cdn.mediavalet.com/usil/starkeyhearingtech/Jy8svlpGWUKq0ZNCEtAkCw/And0_0zxSUeeH8KqLdG2gA/Original/starkey%20bestellformular%20ido%202022.pdf',
    },
    {
        title: 'Order Form',
        brand: CON.AUDIBEL,
        localePdf:
            'https://cdn.mediavalet.com/usil/starkeyhearingtech/CL9_foZ92UO-VWSqfl9DHw/6SGv-ycG5U2oXjrWy0Rkng/Original/Audibel%20IdO%20Bestellformular.pdf',
    },
    {
        title: 'Order Form',
        brand: CON.NUEAR,
        localePdf:
            'https://cdn.mediavalet.com/usil/starkeyhearingtech/Z_QO7JzeTES3A0eU5ITluQ/1eDCPGnWGEOl2D0vBTcsIg/Original/NuEar%20IdO%20Bestellformular.pdf',
    },
];
const EMFORMS_DE: IOrderCenterItem[] = [
    {
        title: 'Earmold Order Form',
        localePdf:
            'https://cdn.mediavalet.com/usil/starkeyhearingtech/nyn39wQizk62nkAQRfbmyA/7gJQkPfjeE6gOp0O1H6wFQ/Original/starkey%20bestellformular%20otoplastik.pdf',
    },
];
const SERVICE_REPAIR_FORMS_DE: IOrderCenterItem[] = [
    {
        title: 'Loss Report',
        localePdf:
            'https://cdn.mediavalet.com/usil/starkeyhearingtech/CJ5lMXk-REKYyKLcp-YZCg/DI6z5lktJkCqApMiZeRNkg/Original/verlustmeldung.pdf',
    },
    {
        title: 'Return',
        localePdf:
            'https://cdn.mediavalet.com/usil/starkeyhearingtech/sKmLIAciU0yptSS6-Zip-w/BSBb2G9gQECslOtt26qLLQ/Original/starkey%20ruecksendeschein.pdf',
    },
    {
        title: 'Repair',
        localePdf:
            'https://cdn.mediavalet.com/usil/starkeyhearingtech/46YG7jInP0iGip_r8-Ucew/2xLty2IRuUOhZmTeuernvQ/Original/starkey%20reparaturauftrag.pdf',
    },
    {
        title: 'Credit Form',
        localePdf:
            'https://cdn.mediavalet.com/usil/starkeyhearingtech/HTOt0Mu_lE629Gjiw4NnhA/S5yphDXSA0ycoj2MKgGNTg/Original/gutschrift%20formular.pdf',
    },
];

const FORMS_DE: IOrderCenterForm = {
    productForms: PRODUCT_FORMS_DE,
    earmoldForms: EMFORMS_DE,
    serviceRepairForms: SERVICE_REPAIR_FORMS_DE,
};
//==================================================//
//TODO: if country codes don't have an enum in the Front End we should setup one that gets populated and built from the back end
export function resolveProductForms(
    countryCode: string,
    brand: string
): IOrderCenterForm {
    switch (countryCode) {
        case CON.CA:
            return FORMS_CA;
        case CON.KR:
            return FORMS_KR;
        case CON.DE:
            return {
                ...FORMS_DE,
                productForms: CON.PRODUCT_FORM_BRANDS_DE.includes(brand)
                    ? FORMS_DE.productForms.filter(
                          (productForm) => productForm.brand === brand
                      )
                    : [FORMS_DE.productForms[0]],
            };
        default:
            return FORMS_CA; //TDOD: This is not correct. Set up a proper default or throw an exception.
    }
}

export const PDFSURL = '/pdfs/ordering/';
export const ESTORE_INSTRUCTION_URL = 'eStore_Instructions.pdf';
